import React from "react";

const GalleryModal = ({ isOpen, onClose, title, images = [] }) => {
  if (!isOpen) return null;

  return (
    <div className={`home-modal ${isOpen ? "active" : ""}`}>
      <div className="home-modal-content">
        {/* Close button */}
        <button className="home-modal-close" onClick={onClose}>
          &times;
        </button>

        {/* Title */}
        <h2>{title}</h2>

        {/* Images Grid */}
        <div className="home-modal-gallery-grid">
          {images.map((img, index) => (
            <img key={index} src={img} alt={`${title} ${index + 1}`} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GalleryModal;
